var render = function render(){var _vm=this,_c=_vm._self._c;return _c('download-excel',{staticClass:"btn btn-primary",attrs:{"fetch":_vm.fetchData,"data":_vm.data,"fields":_vm.fields,"meta":_vm.jsonMeta,"name":_vm.name,"header":_vm.title,"type":"xls"}},[_c('label',{staticClass:"download-csv",staticStyle:{"cursor":"pointer"}},[_vm._v("XLS")])])
}
var staticRenderFns = []

export { render, staticRenderFns }